<template>
  <v-container
    fill-height
    fluid
    class="login-bg pa-0 ma-0"
    style="width: 100vw; height: 100vh"
  >
    <v-row
      align="center"
      justify="center"
      class="ma-0"
      style="min-height: 100vh"
    >
      <v-col cols="12" sm="8" md="4" class="pa-4">
        <v-card class="pa-6 text-center elevation-12 rounded-xl">
          <v-img
            src="@/assets/nikah-connect-logo.png"
            contain
            max-width="120"
            class="mx-auto mb-3"
          ></v-img>

          <!-- <h2 class="font-weight-bold mb-4 text--primary">Welcome Back</h2> -->
          <p class="grey--text text--darken-1 mb-6">
            Log in to continue your Nikah Connect journey.
          </p>

          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="email"
              label="Email Address"
              prepend-inner-icon="mdi-email"
              :rules="[(v) => /.+@.+/.test(v) || 'E-mail must be valid']"
              outlined
              dense
            ></v-text-field>

            <v-text-field
              v-model="password"
              label="Password"
              prepend-inner-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showPassword = !showPassword"
              :type="showPassword ? 'text' : 'password'"
              :rules="[(v) => !!v || 'Password is required']"
              outlined
              dense
              @keydown.enter="doLogin"
            ></v-text-field>

            <v-btn
              block
              color="primary"
              class="mt-4 py-2 font-weight-bold"
              :loading="loading"
              @click="doLogin"
            >
              Log In
            </v-btn>

            <div class="mt-3">
              <a
                href="javascript:void(0)"
                class="font-weight-medium text--secondary"
                @click.prevent="showForgotPasswordInfo"
              >
                Forgot Password?
              </a>
              <!-- <router-link
                to="/forgot-password"
                class="font-weight-medium text--secondary"
              >
                Forgot Password?
              </router-link> -->
            </div>

            <div class="mt-3 grey--text">
              Don’t have an account?
              <router-link to="/signup" class="font-weight-medium"
                >Sign Up</router-link
              >
            </div>
          </v-form>
          <div class="mt-6 text-caption grey--text">
            Version {{ appVersion }}
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar" timeout="4000" color="error">
      {{ snackbarText }}
      <v-btn text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import authService from "../service.js";
import pkg from "../../../../package.json";

export default {
  data() {
    return {
      valid: false,
      showPassword: false,
      loading: false,
      snackbar: false,
      snackbarText: "",
      email: "",
      password: "",
      appVersion: pkg.version,
    };
  },
  methods: {
    showForgotPasswordInfo() {
      this.$swal({
        title: "Coming Soon!",
        text: "We're working on the password reset feature. If you have any issues accessing your account, please contact us at info@NikahConnect.org.",
        icon: "info",
        confirmButtonText: "Okay",
        confirmButtonColor: "#2A6465",
      });
    },
    doLogin() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;

      authService
        .authenticate({
          email: this.email,
          password: this.password,
        })
        .then((response) => {
          console.log("response", response);
          this.checkResponse(response);
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.$swal(
            "Login failed!",
            "Please check your email and password.",
            "error"
          );
        });
    },
    checkResponse(response) {
      if (response.status === 400) {
        this.$swal
          .mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: "Invalid User",
          });
      } else {
        // this.initOrganization(response);
        this.$router.push("/");
      }
    },
  },
};
</script>

<style scoped>
.login-bg {
  background: linear-gradient(145deg, #f8fafc, #f2f9f3);
  min-height: 100vh;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
}
.v-card {
  border-radius: 20px;
}
.text--primary {
  color: #2a6465 !important;
}
.text--secondary {
  color: #e6be8a !important;
}

.text-caption {
  font-size: 0.75rem;
  opacity: 0.8;
}

/* Ensure full screen on desktop */
@media (min-width: 768px) {
  .login-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
}
</style>